import { render } from "./ContentForm.vue?vue&type=template&id=0f884098"
import script from "./ContentForm.vue?vue&type=script&lang=js"
export * from "./ContentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__